// removed by extract-text-webpack-plugin
module.exports = {"heading":"Heading__heading","content":"Heading__content"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Heading/Heading.css
// module id = 1151
// module chunks = 8